import React from 'react';
import PropTypes from "prop-types";
import ReactDOM from 'react-dom';

class TutorialOverlayView extends React.Component {

	render() {
        return (
            <div class="main2" id="main">
                <div class="xtut" onClick={this.props.clickX}>
                    X
                </div>
            </div>
        );
	}
}

TutorialOverlayView.propTypes = {
  clickX: PropTypes.func,
};

export default TutorialOverlayView;